import { createContext } from 'react';

export interface UserInfo {
  userId: string;
  email?: string;
  name?: string;
  picture?: string;
  // Custom Locus claims
  clientId?: string;
  homeTenant?: string;
  roleId?: string;
  targetTenant?: string;
  [key: string]: unknown;
}

export interface UserContextValue {
  user: UserInfo | null;
  isLoading: boolean;
}

export const UserContext = createContext<UserContextValue | null>(null);
